<template>
  <div class="sign">
    <div class="con-imgs" v-if="details && details.poster">
      <img class="img" :src="details && details.poster.url" alt=""/>
    </div>
    <div class="comment-div" id="scroll">
      <div class="box">
        <div class="box_title">学习评价</div>
        <van-list
          id="list"
          v-model="commentState.loading"
          :finished="commentState && commentState.finished"
          :finished-text="commentState.finishText"
          :offset="10"
          @load="handleGetCommentList"
          class="comment-block"
        >
          <div v-for="(item, index) in commentListArr" :key="index">
            <div class="header-div" v-if="item && item.userInfo">
              <img :src="item && item.userInfo.headPicUrl" class="header-cover" alt=""/>
              <div class="header-con">
                <div class="header-name">
                  {{ item && item.userInfo.nickName }}
                </div>
                <div class="comment-con">
                  <div class="con-txt">{{ item && item.userInfo.hospitalName }}</div>
                </div>
              </div>
            </div>
            <div class="con">{{ item && item.content }}</div>
          </div>
        </van-list>
      </div>
    </div>
    <template>
      <div class="btn" v-if="!details.joinSign && !loading">
        <div v-if="(details.unlockSign || !details.unlockMethod) && !loading" class="sign-btn" @click="handleConfirm">
          立即报名
        </div>
        <div class="change_btn" v-else>
          <div class="lock">
            <img class="img" src="../../assets/train/lock.png" alt=""/>
            <span>{{ `可使用${details.unlockCost}积分解锁` }}</span>
          </div>
          <div class="c_btn" @click="handleClick">立即兑换</div>
        </div>
      </div>
      <van-dialog v-model="show" title="积分解锁" :show-confirm-button="false">
        <div class="di_content">您将消耗{{ details && details.unlockCost }}积分兑换该训练营,是否确认兑换?</div>
        <!-- <div class="di_content">您将消耗{{ details && details.unlockCost }}积分兑换该训练营或者使用勋章解锁,是否确认兑换?</div> -->
        <div class="di_btn_group">
          <div class="di_btn cancel" @click="() => (show = false)">取消</div>
          <div class="di_btn ok" @click="handleClickOk">确认</div>
        </div>
      </van-dialog>
      <div class="fail_modal" v-if="showChange">
        <img class="img" :src="changeStatus ? ChangeOk : changeFail" alt=""/>
        <p class="msg">{{ changeStatus ? "兑换成功" : "兑换失败" }}</p>
        <p class="tips">{{ exchangeTxt }}</p>
      </div>
    </template>
  </div>
</template>
<script>
import ChangeOk from '../../assets/train/change_ok.png'
import changeFail from '../../assets/train/change_fail.png'
import {getTrainingDetails, getTrainingFeedback, unlockTraining, signTraning} from '@/api/training'
import {getShareInfo} from '@/utils/wxShare'
// import { modifyURLParam } from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'

const UserProfile = {
  data() {
    return {
      details: {},
      commentState: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      commentListArr: [],
      isNone: false,
      commentableId: '',
      targetContent: '',
      total: 0,
      show: false,
      ChangeOk,
      changeFail,
      changeStatus: false,
      showChange: false,
      exchangeTxt: '',
      loading: true
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
  },
  mounted() {
    getTrainingDetails({
      campId: this.$route.query.campId
    }).then(res => {
      this.details = res.data
      window.sessionStorage.setItem('mainId', this.details.id)
      window.sessionStorage.setItem('serviceId', this.details.id)
      let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
      window.sessionStorage.setItem('entrance', entrance)
      window.sessionStorage.setItem('traceTitle', this.details.title)
      let desc = '学习电生理，训练营等你！'
      let images = this.details.cover ? this.details.cover.url : `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`
      getShareInfo({
        title: this.details.title,
        titleTimeLine: this.details.title,
        desc,
        link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '20'),
        linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '21'),
        images,
      })
      setTimeout(() => {
        this.loading = false
      })
      this.handleGetCommentList()
    })
  },
  methods: {
    handleConfirm() {
      if (this.loading) return
      this.loading = true
      let params = {
        campId: this.$route.query.campId,
        userId: this.userInfo.id
      }
      signTraning(params)
        .then(res => {
          if (res.code === 0) {
            if (!this.showChange) {
              this.$toast('报名成功')
            }
            setTimeout(() => {
              this.loading = false
              this.showChange = false
              this.$router.push({
                path: `/trainCourse?campId=${this.$route.query.campId}`
              })
            }, 1500)
          }
        })
        .catch(err => {
          this.loading = false
          this.$toast(err.msg)
        })
    },
    handleClose() {
      this.$parent.showComment = false
      this.$parent.show = true
      this.commentableId = ''
    },
    handleGetCommentList() {
      if (!this.details.campMainId) return
      let params = {
        pageNum: this.commentState.pageNo,
        pageSize: this.commentState.pageSize,
        campMainId: this.details.campMainId,
      }
      getTrainingFeedback(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.commentState.loading = false
              this.commentState.finished = true
              return false
            }
            this.total = res.data.total
            if (res.data.list.length < this.commentState.pageSize) {
              this.commentState.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.commentListArr = this.commentListArr.concat(res.data.list)
            }
            this.commentState.pageNo++
            if (this.commentListArr.length === 0) {
              this.isNone = true
              this.commentState.finishText = '暂无评论'
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
        .finally(() => {
          this.commentState.loading = false
        })
    },
    handleClick() {
      this.show = true
    },
    handleClickOk() {
      this.show = false
      let params = {
        openId: this.userInfo.iepOpenId,
        userId: this.userInfo.id,
        baseId: this.$route.query.campId,
        type: 1,
        unlockMethod: 1,
        unlockCost: this.details.unlockCost,
        unlockContent: `兑换${this.details.title}训练营`
      }
      unlockTraining(params).then(res => {
        this.changeStatus = true
        this.showChange = true
        this.exchangeTxt = res.msg
        this.handleConfirm()
      }).catch((err) => {
        this.changeStatus = false
        this.showChange = true
        this.exchangeTxt = err.msg
        setTimeout(() => {
          this.showChange = false
        }, 1000)
      })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.sign {
  min-height: 100vh;
  background: #F9F8F7;
  padding-bottom: 62px;
  box-sizing: border-box;
  position: relative;
}

.con-imgs {
  .img {
    display: block;
    width: 100%;
  }
}

.comment-div {
  width: 100%;
  padding: 10px 6px;
  box-sizing: border-box;

  .loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -30%);
  }
}

.box_title {
  width: 100%;
  height: 46px;
  padding: 16px 0 0 11px;
  box-sizing: border-box;
  background-color: #fff;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}

.comment-block {
  width: 100%;
  padding: 16px 11px;
  box-sizing: border-box;
  background-color: #fff;
}

.header-div {
  display: flex;
  margin-bottom: 8px;

  .header-cover {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-right: 8px;
    object-fit: cover;
  }

  .header-con {
    .header-name {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      color: #000000;
    }

    .con-txt {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #b1b1b1;
    }
  }
}

.con {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  margin-bottom: 20px;
  margin-top: 8px;
  line-height: 20px;
}

.btn {
  width: 100%;
  height: 62px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;

  .sign-btn {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background: #EB1700;
    width: 343px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 100px;
    margin: 12px auto;
  }

  .change_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .lock {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #EB1700;
      display: flex;
      align-items: center;
      padding: 22px 15px;
      box-sizing: border-box;

      .img {
        width: 12px;
        height: 13px;
        margin-right: 3px;
      }
    }

    .c_btn {
      width: 128px;
      height: 42px;
      background: #EB1700;
      box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
      border-radius: 22px 22px 22px 22px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 42px;
      margin-right: 12px;
    }
  }
}

.van-dialog {
  width: 320px;
  height: 195px;
  background: url("../../assets/train/di_bg.png") no-repeat;
  background-size: 100% 100%;

  /deep/ .van-dialog__header {
    font-family: Source Han Sans CN, Source Han Sans CN;
    color: #000000;
    font-weight: 600;
    font-size: 17px;
    padding-top: 15px;
    line-height: 24px;
  }
}

.di_content {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  padding: 28px 26px;
  box-sizing: border-box;
  line-height: 21px;
}

.di_btn_group {
  display: flex;
  padding: 0 17px;
  box-sizing: border-box;
  justify-content: space-between;

  .di_btn {
    width: 130px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    border-radius: 20px 20px 20px 20px;
  }

  .ok {
    background: #EB1700;
    box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
    color: #fff;
  }

  .cancel {
    background: rgba(0, 0, 0, 0.08);
    color: #7a8494;
  }
}

.fail_modal {
  width: 200px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 19px 19px 19px 19px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 24px;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 9;

  .img {
    width: 42px;
    width: 42px;
    margin-bottom: 15px;
  }

  .msg {
    width: 100%;
    text-align: center;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    color: #ffffff;
    margin-bottom: 4px;
  }

  .tips {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    line-height: 20px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/training/trainDetails.vue